class Routes  {
	constructor() {
		$(document).on('click', '#search-routes', this.handleSearch);
	}

	handleSearch() {
		let search = $('input[name="search-field-routes"]').val();
		if (search == '') {
			$('div.routelist').find('div.collapse.show').collapse('hide');
			$('div.routelist').find('div.row').show();
			$('div.routelist').find('.bg-warning').removeClass('bg-warning');
		} else {
			let order = $('.my_account_orders').find('tr[data-ordernumber="' + search + '"]');
			order.addClass('bg-warning');
			order.parents('div.collapse').first().addClass('active');
			$('div.routelist').find('> div.row').hide();
			order.parents('div.collapse').first().parent().show();
			console.log(
				order.parents('div.collapse').first().parent()
			);
			order.parents('div.routelist').find('div.collapse:not(.active)').collapse('hide');
			order.parents('div.collapse').first().collapse('show');
			order.parents('div.collapse').first().removeClass('active');
		}
	}
}

export default Routes;